import dialogStore from '../stores/dialog';

function ownerContext(owner) {
    const props = owner.props || {};
    const userStore = props.stores?.userStore || owner.stores?.userStore || owner;
    const identities = Object.keys(props).sort().flatMap(key => {
        const value = props[key];
        if (/^(id|uuidv4|.*Id|.*Md5|objectName|field|type|isNew)$/.test(key)) return [key, value];
        if (value && typeof value === 'object' && (value.id != null || value.uuidv4 != null)) {
            return [key, value.id, value.uuidv4];
        }
        return [];
    });
    return [userStore.user?.id, userStore.customer?.id, ...identities];
}

// Keep a migrated action single-flight while it waits for decisions and completes its existing work.
// Callers can include selected store IDs or other context that is not represented in their props.
export function beginDialogAction(owner, key, readContext = () => []) {
    const version = dialogStore.contextVersion;
    const hadBase = !!owner.base;
    const snapshot = () => JSON.stringify([ownerContext(owner), readContext()]);
    const initial = snapshot();
    const token = dialogStore.beginAction(owner, key);
    if (!token) return null;
    return {
        isCurrent: () => dialogStore.contextVersion === version
            && (!hadBase || !!owner.base?.isConnected) && snapshot() === initial,
        finish: () => dialogStore.finishAction(owner, key, token),
    };
}
